import {Component, inject, OnInit} from '@angular/core';
import {AuthService} from "../../../services/auth.service";
import {ToastService} from "../../../services/toast.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
  standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  registrationForm!: FormGroup;
  isVerified: boolean | null = null;
  resetPasswordSent: any = false;

  private readonly authService = inject(AuthService);
  private readonly fb = inject(FormBuilder);
  private readonly toastService = inject(ToastService);

  ngOnInit() {
    this.registrationForm = this.fb.group({
      email: ['',
        [Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+"), Validators.required]],
    })
  }

  tryAgain() {
    this.isVerified = false;
    window.location.reload();
  }

  SendResetPassword() {
    this.registrationForm.markAllAsTouched();
    if (this.registrationForm.invalid) {
      this.toastService.showToast('Please fill out all required fields.', 'error');
      return;
    }

    const email = this.registrationForm.value.email;
    this.authService.forgotPassword(email).then((res: any) => {
      this.resetPasswordSent = res.isSuccess;
      if (res.error) {
        this.toastService.showToast(res.error.error, 'error');
      }
    });
  }
}
